function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
import { checkAllLimits } from 'shared/helpers/purchase-limits';
import { productIncludedInType } from 'shared/helpers/check-limits/utils';
export var maxQuantity = function(key, cart, isMedical, order) {
    var useMultiSubcategories = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, configurablePurchaseLimitsFeatureEnabled = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    var dispensary = order.dispensary, customerState = order.customerState;
    var _cart_key = cart[key], quantity = _cart_key.quantity, product = _cart_key.product;
    var currentMaxQuantity = quantity;
    var withinLimits = false;
    while(!withinLimits){
        var limitsCheck = checkAllLimits({
            newItemId: key,
            itemBeingAdded: _object_spread_props(_object_spread({}, _.clone(cart[key])), {
                quantity: currentMaxQuantity
            }),
            existingItems: cart,
            medical: isMedical,
            dispensary: dispensary,
            changingQuantity: true,
            customerState: customerState,
            complianceOnly: true,
            useMultiSubcategories: useMultiSubcategories,
            configurablePurchaseLimitsFeatureEnabled: configurablePurchaseLimitsFeatureEnabled
        });
        // Make sure we're not inadvertently removing products whose types
        // are still within the limits when switching from med -> rec
        var typesOverLimit = limitsCheck.typesOverLimit;
        var productExceedsLimits = void 0;
        if ((typesOverLimit === null || typesOverLimit === void 0 ? void 0 : typesOverLimit.length) > 0) {
            productExceedsLimits = _.some(typesOverLimit, function(exceededType) {
                return productIncludedInType(product, exceededType, order, useMultiSubcategories);
            });
        }
        if (limitsCheck.withinLimits || !productExceedsLimits || currentMaxQuantity === 0) {
            withinLimits = true;
        } else {
            currentMaxQuantity -= 1;
        }
    }
    return currentMaxQuantity;
};
